module.exports = __webpack_public_path__ + "img/tuceng.9eaa11fa.png";